const ApiBaseURLProps = {
  // apiBaseURL: process.env.api_url || 'http://172.16.0.67:8081',
  // apiBaseURL: process.env.api_url || "http://172.16.0.67:8081",
  // apiBaseURL: process.env.api_url || "http://192.168.1.117:8081",
  // apiBaseURL: process.env.api_url || "http://localhost:8081",
  // apiBaseURL: process.env.api_url || "http://172.16.4.102:8081",
  // apiBaseURL: process.env.api_url || "http://172.16.0.67:8029",

  //  apiBaseURL: process.env.REACT_APP_API_URL || "https://10.100.220.10/api",
  //  apiBaseURL: process.env.REACT_APP_API_URL || "http://localhost:8081",
  // apiBaseURL: process.env.REACT_APP_API_URL || "https://172.16.0.67/api",
  // apiBaseURL: process.env.REACT_APP_API_URL || "http://localhost:8081",

  apiBaseURL: process.env.REACT_APP_API_URL || "https://ckyc.cdsc.com.np/api",


  biometricsURL: "https://localhost:8003/mfs100/",
  videoUrl: "ckyc.cdsc.com.np",
};

export default ApiBaseURLProps;
